export const DAILY_ENTRY_CONTEXT = {
  primaryAxes: ['terminal', 'entry-date'],
  dependsOn: ['directory employee-grid', 'terminal assignment truth'],
  unlocks: ['driver roster scope', 'daily write surface', 'terminal-level management flow'],
};
